/**
 * The Dashboard's one line of winter work (services/winterWork.summary): shown from the mid-November nudge to the
 * end of the window, or whenever a winter job is still waiting for its date. Tap it and the Winter work page opens.
 */
import React from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { Snowflake } from 'lucide-react';
import { api } from '../services/api';

type Summary = { show: boolean; words: string; counts: { to_date?: number } };

export default function WinterSummary() {
  const { data } = useQuery<Summary>('winter-summary', () => api.get('/winter/summary').then(r => r.data), { staleTime: 60_000, retry: false });
  if (!data?.show) return null;
  const waiting = Number(data.counts?.to_date) > 0;
  return (
    <Link to="/winter" className={`press flex items-center gap-3 rounded-2xl border px-4 py-3 text-sm font-semibold ${waiting ? 'bg-sky-50 border-sky-300 text-sky-900' : 'bg-white border-gray-200 text-gray-800'} hover:bg-sky-100/60`}>
      <Snowflake className="h-5 w-5 text-sky-600 flex-shrink-0" aria-hidden />
      <span className="min-w-0 flex-1 truncate">{data.words}</span>
      <span className="text-xs font-bold text-sky-700 whitespace-nowrap">Winter work →</span>
    </Link>
  );
}
